import { issuesToFormErrors, toFieldIssues, type AppError, type FieldLabels } from '@flow/core';
import type { z } from 'zod';

/**
 * Validate a form with the shared zod schema and the shared plain-language messages.
 * Returns every field error at once (Mantine's `validate` option).
 */
export const zodValidate = <S extends z.ZodType>(schema: S, labels: FieldLabels = {}) => (values: unknown) => {
  const r = schema.safeParse(values);
  return r.success ? {} : issuesToFormErrors(toFieldIssues(r.error, labels));
};

/** Put a use-case validation error back onto the form fields. Returns true if it was a field error. */
export const applyErrors = (form: { setErrors: (e: Record<string, string>) => void }, e: AppError) => {
  if (e.kind !== 'validation') return false;
  form.setErrors(issuesToFormErrors(e.issues));
  return true;
};
